<template>
  <div class="container-fluid">
    <input v-if="galleryOptions !== null" v-file-uploader="galleryOptions" type="file" name="files" class="gallery_media" />
  </div>
</template>

<script>
import VueFileUploader from "@/directives/VueFileUploader.js";
export default {
  name: "TodoImages",
  components: {},
  directives: {
    VueFileUploader
  },
  props: ['venueTaskId', 'imageUrls'],
  data() {
    return {
      galleryOptions: null
    };
  },
  mounted() {
    const files = this.imageUrls.map(imageUrl => (
      {
        name: 'venue.jpg',
        size: 1,
        type: 'image/jpg',
        file: imageUrl,
        data: {
          url: imageUrl
        }
      }
    ));

    this.galleryOptions = {
      deletingImage: false,
      uploadUrl: process.env.VUE_APP_API_BASE_URL +'/VenueTasksImages/' + this.venueTaskId,
      deleteUrl: process.env.VUE_APP_API_BASE_URL +'/VenueTasksImages/' + this.venueTaskId,
      sortUrl: process.env.VUE_APP_API_BASE_URL +'/VenueTasksImages/' + this.venueTaskId,
      files: files
    };
  },
  beforeDestroy: function() {
  },
  methods: {}
};
</script>

<style>
.fileuploader-theme-gallery .fileuploader-input-inner {
    /*max-height:90px !important;*/
    min-height:100px !important;
}
</style>